/** Persistence for the `Don't show again` choice. Swap it via `ModalProvider`'s `storage` prop. */
export interface ModalStorage {
  get: (key: string) => boolean;
  set: (key: string, value: boolean) => void;
}

const PREFIX = 'smartsash.modal.suppress.';

/** Default adapter — `localStorage`, guarded for private-mode / SSR (falls back to no persistence). */
export const localStorageAdapter: ModalStorage = {
  get(key) {
    try {
      return globalThis.localStorage.getItem(PREFIX + key) === '1';
    } catch {
      // storage unavailable (private mode / SSR)
      return false;
    }
  },
  set(key, value) {
    try {
      const store = globalThis.localStorage;
      if (value) store.setItem(PREFIX + key, '1');
      else store.removeItem(PREFIX + key);
    } catch {
      // storage unavailable — suppression simply won't persist
    }
  },
};

/** Non-persistent adapter (useful for tests / opting out of storage). */
export const noopStorage: ModalStorage = {
  get: () => false,
  set: () => undefined,
};
